import {Order} from '../../types';
import { deliveryDateTypes } from "../../static_data/deliveryDateTypes";
import { isAsapDelivery } from '../order/isAsapDelivery';
export function filterAsapDeliveries(orders : Order[], returnRest = false) : Order[]{

    if(returnRest) return orders.filter(order => !isAsapDelivery(order));
    return orders.filter(isAsapDelivery);

}       